module.exports = __webpack_public_path__ + "static/media/icon_alarm.5fa768e5.svg";